import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import SocialPostSections from './SocialPostSections'

import { clearRightSocialPosts, getRight, getRightSocialPosts } from '../../../../modules/actions/rights'
import { clearAccessibleSocialPages, getAccessibleSocialPages } from '../../../../modules/actions/socialAccounts'
import {
  rightSelector,
  rightSocialPostsErrorSelector,
  rightSocialPostsWasLoadedSelector,
  rightWasRefetchedSelector
} from '../../../../modules/selectors/rights'
import {
  accessibleSocialPagesSelector,
  accessibleSocialPagesWasLoadedSelector
} from '../../../../modules/selectors/socialAccounts'

import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../constants/selectLists/platformList'

const SocialPostsContent = ({ rightId }) => {
  const dispatch = useDispatch()

  const right = useSelector(rightSelector)
  const rightWasRefetched = useSelector(rightWasRefetchedSelector)
  const socialPostsWasLoaded = useSelector(rightSocialPostsWasLoadedSelector)
  const socialPostsError = useSelector(rightSocialPostsErrorSelector)
  const facebookPages = useSelector(accessibleSocialPagesSelector)
  const facebookPagesWasLoaded = useSelector(accessibleSocialPagesWasLoadedSelector)

  const { pages: rightPages } = right

  const rightFacebookPageId = rightPages?.find(page => page.provider === FACEBOOK_PROVIDER_PLATFORM)?.['page_id']

  const facebookPageData = facebookPages.find(page => page['external_id'] === rightFacebookPageId)

  const socialPostsDidLoading = socialPostsWasLoaded || socialPostsError

  const additionalDataIsLoading = !facebookPagesWasLoaded || !rightWasRefetched

  const onRefreshButtonClickHandler = useCallback(() => {
    dispatch(clearRightSocialPosts())

    dispatch(getRight(rightId, { isAsyncMode: true }))
  }, [dispatch, rightId])

  useEffect(() => {
    dispatch(
      getAccessibleSocialPages({
        platform: FACEBOOK_PROVIDER_PLATFORM
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (!socialPostsDidLoading && rightWasRefetched) {
      dispatch(
        getRightSocialPosts({
          right: rightId
        })
      )
    }
  }, [dispatch, rightFacebookPageId, rightId, socialPostsDidLoading, rightWasRefetched])

  useEffect(
    () => () => {
      dispatch(clearRightSocialPosts())
      dispatch(clearAccessibleSocialPages())
    },
    [dispatch]
  )

  return (
    <SocialPostSections
      facebookPageData={facebookPageData}
      additionalDataIsLoading={additionalDataIsLoading}
      onRefreshButtonClickHandler={onRefreshButtonClickHandler}
    />
  )
}

SocialPostsContent.propTypes = {
  rightId: PropTypes.string.isRequired
}

export default SocialPostsContent
